type ColorVariations = {
  rgb: string;
  contrast: string;
  contrastRgb: string;
  shade: string;
  tint: string;
};

const DEFAULT_PRIMARY = '#ff7000';
const DEFAULT_TERTIARY = '#1d3460';

const normalizeHex = (hexColor: string) => {
  const clean = (hexColor || '').replace('#', '').trim();
  return /^[0-9a-fA-F]{6}$/.test(clean) ? `#${clean}` : null;
};

const colorVariations = (hexColor: string): ColorVariations => {
  const normalized = normalizeHex(hexColor) || DEFAULT_PRIMARY;
  const clean = normalized.substring(1);
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return {
    rgb: `${r},${g},${b}`,
    contrast: luminance > 0.5 ? '#000000' : '#ffffff',
    contrastRgb: luminance > 0.5 ? '0,0,0' : '255,255,255',
    shade: `#${Math.round(r * 0.9).toString(16).padStart(2, '0')}${Math.round(g * 0.9).toString(16).padStart(2, '0')}${Math.round(b * 0.9).toString(16).padStart(2, '0')}`,
    tint: `#${Math.round(r + (255 - r) * 0.1).toString(16).padStart(2, '0')}${Math.round(g + (255 - g) * 0.1).toString(16).padStart(2, '0')}${Math.round(b + (255 - b) * 0.1).toString(16).padStart(2, '0')}`
  };
};

const setIonicColor = (name: string, hexColor: string) => {
  const normalized = normalizeHex(hexColor);
  if (!normalized) return;

  const variations = colorVariations(normalized);
  const root = document.documentElement.style;
  root.setProperty(`--ion-color-${name}`, normalized);
  root.setProperty(`--ion-color-${name}-rgb`, variations.rgb);
  root.setProperty(`--ion-color-${name}-contrast`, variations.contrast);
  root.setProperty(`--ion-color-${name}-contrast-rgb`, variations.contrastRgb);
  root.setProperty(`--ion-color-${name}-shade`, variations.shade);
  root.setProperty(`--ion-color-${name}-tint`, variations.tint);
};

const deriveTertiary = (primaryColor: string) => {
  const normalized = normalizeHex(primaryColor) || DEFAULT_PRIMARY;
  const clean = normalized.substring(1);
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#121212' : '#ffffff';
};

export const applyEmpresaTheme = (empresa: any) => {
  const primary = normalizeHex(empresa?.color);
  if (!primary) return;

  setIonicColor('primary', primary);
  setIonicColor(
    'tertiary',
    normalizeHex(empresa?.colorTertiary || empresa?.tertiaryColor) || deriveTertiary(primary)
  );
};

export const resetEmpresaTheme = () => {
  setIonicColor('primary', DEFAULT_PRIMARY);
  setIonicColor('tertiary', DEFAULT_TERTIARY);
};

